module.exports = __webpack_public_path__ + "./img/Wifi_signal_strength.png";